const config = {
  url: 'http://api.ecatalog.mcash.id/api/v1',
  token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImZhZXJ1bHNhbGFtdW4iLCJzdWIiOiIxIiwiaWF0IjoxNjQwNzkzNzAyLCJleHAiOjE2NzIzMjk3MDJ9.CUR6K5MJlb8sqzEBlvhSX3Jv0iRcxtjDgmIWMEWvlH0'
};

export default config;
